// Footer Links Start
function toggleFooterLinks() {
  const footerOuterCont = document.querySelector('.footer_outer_cont');
  const footerLinkDiv = document.querySelector('.footer_link_div');

  footerOuterCont.addEventListener('click', function() {
    if (footerLinkDiv.classList.contains('expand')) {
      // Collapse the div
      footerLinkDiv.style.maxHeight = '0px';
      footerLinkDiv.classList.remove('expand');
    } else {
      // Expand the div - set max-height dynamically based on scrollHeight
      footerLinkDiv.style.maxHeight = footerLinkDiv.scrollHeight + 'px';
      footerLinkDiv.classList.add('expand');
    }
  });
}
document.addEventListener('DOMContentLoaded', toggleFooterLinks);
// Footer Links End

// Footer General FAQs Start

document.addEventListener("DOMContentLoaded", function () {
  const faqItems = document.querySelectorAll(".faq");
  faqItems.forEach(function (item) {
    const question = item.querySelector(".question");
    const answer = item.querySelector(".answer");
    question.addEventListener("click", function () {
      faqItems.forEach(function (faqItem) {
        if (faqItem !== item) {
          faqItem.querySelector(".answer").style.display = "none";
          faqItem.querySelector(".question").classList.remove("open");
        }
      });
      if (answer.style.display === "block") {
        answer.style.display = "none";
        question.classList.remove("open");
      } else {
        answer.style.display = "block";
        question.classList.add("open");
      }
    });
  });  
});


// Footer General FAQs End
// Product Specification Start

document.addEventListener("DOMContentLoaded", function () {
  const helpTooltips = document.querySelectorAll(".spec_ul li");
  helpTooltips.forEach(function (tooltip) {
    const tooltipText = tooltip.getAttribute("data-tooltip");
    const tooltipBox = document.createElement("div");
    tooltipBox.classList.add("tooltip-box");
    tooltipBox.textContent = tooltipText;
    tooltip.appendChild(tooltipBox);
  });
});


// Product Specification End
// Prototype T&C Start

$(document).ready(function () {
  $("#tnc_link").on("click", function (event) {
    event.preventDefault();
    var targetId = "tnc";
    var additionalScroll = 100;
    var targetPosition = $("#" + targetId).offset().top - additionalScroll;
    $("html, body").animate({
      scrollTop: targetPosition
    }, 1000);
  });
});

function toggleTnc() {
  var outerCont = document.getElementById("TncOuterDiv");
  outerCont.classList.toggle("active");

  var linkDiv = document.getElementById("TncInnerDiv");
  var style = window.getComputedStyle(linkDiv);

  if (style.display === "block") {
    linkDiv.style.opacity = "0";
    setTimeout(function () {
      linkDiv.style.display = "none";
    }, 500);
  } else {
    linkDiv.style.display = "block";
    setTimeout(function () {
      linkDiv.style.opacity = "1";
    }, 50);
  }
}

// Prototype T&C End 
// Automatic Filename as ALT tag Start

function updateAltAttribute() {
    var images = document.getElementsByTagName('img');
    for (var i = 0; i < images.length; i++) {
        var image = images[i];
        var src=image.src;
        var filename = src.split('/').pop().split('#')[0].split('?')[0];
      // if (image.alt == blank){
      //   image.alt = filename;
      // }
    }
}
document.addEventListener("DOMContentLoaded", updateAltAttribute);

// Automatic Filename as ALT tag End


function check_alt(color_image, data_id) {
  $('.product__thumb-item').hide();
  $('.product__thumb-item img').each(function(){
    var alt_val = $(this).attr('alt');
    if(alt_val.indexOf(color_image) !== -1){
      $(this).parents('.product__thumb-item').css('display', 'inline-block');
    }  
  });
  if($('.product__thumb-item img').attr('alt').indexOf(color_image) !== -1){
    $('img[alt="'+color_image+'"]').parents('.product__thumb-item').css('display', 'inline-block');
  }  
  var visibleElementsCount = $('.product__thumb-item:visible').length;  
  if (visibleElementsCount > 8) {
    $('.product__thumb-arrow').show();
    $('.product__thumbs--scroller').addClass('add_padding');
  }
  $('#'+data_id).show().siblings().hide();
  $('.product_specification .custom-content[data-element="'+data_id+'"]').css('display', 'flex').siblings().hide();
}

$(document).on('click', '.variant-input', function(){
  var color_image = $(this).attr('data-value'),
    data_id = $(this).attr('data-id');
  check_alt(color_image, data_id);
});

$(window).on('load', function(){
  var color_image = $('.variant__input--color-swatch:checked').parents('.variant-input').attr('data-value'),
    data_id = $('.variant__input--color-swatch:checked').parents('.variant-input').attr('data-id');
  check_alt(color_image, data_id);
});

$(".product-image-main").on('click touchstart', function() {
  var alt_img = $(this).parents('.product-main-slide').next().find('img').attr('alt');
  $('.variant-input').each( function() {      
    var var_val = $(this).find('input').val();
    console.log(alt_img.indexOf(var_val));
    if ( alt_img.indexOf(var_val) != -1) {
      $(this).find('input').trigger('click');
    }
  })
});

/* variation sold out product start */
document.querySelectorAll('.prod_var_cont').forEach(function(container) {
  const moreButton = container.querySelector('.open-drawer-btn');
  Array.prototype.slice.call(container.children).forEach(function(item) {
    if (item.classList.contains('sold') && !item.classList.contains('hidden')) {
      if (moreButton) {
        container.insertBefore(item, moreButton);
      } else {
        container.appendChild(item);
      }
    }
  });
});
/* variation sold out product end */
/* ── SYLVI UIUX (2026-06-12): Judge.me sticky-header scroll fix ─────────────────
   On pagination Judge.me swaps the review list IN PLACE (no scrollTo — traced), so the new page's top
   reviews sit under the fixed header (.site-header--stuck, ~100px). Same on "Write a review" (form opens
   in place). Fix: on those clicks, actively scroll the widget header / form to sit just below the header. */
(function () {
  function headerEl() { return document.querySelector('.site-header--stuck') || document.querySelector('.site-header'); }
  function headerOffset() {
    var h = headerEl(); if (!h) return 0;
    var cs = getComputedStyle(h);
    if (cs.position !== 'fixed' && cs.position !== 'sticky') return 0;
    return Math.round(h.getBoundingClientRect().height) + 16;
  }
  // Judge.me scrolls the LIST top to y=0 (behind the header) AFTER our click handler runs. So we POLL:
  // once the target element's top is at/above the header band (buried), lift it clear. Poll for ~1.2s to
  // win the race against Judge.me's own scroll, then stop.
  function correctTarget(getEl) {
    var off = headerOffset();
    if (off <= 0) return;            // header not sticky → no overlap, nothing to do
    var tries = 0;
    (function tick() {
      tries++;
      var el = getEl();
      if (el) {
        var top = el.getBoundingClientRect().top;
        // buried = top is between just-above-viewport and the header bottom
        if (top > -40 && top < off) {
          window.scrollBy({ top: top - off, behavior: 'auto' });
        }
      }
      if (tries < 22) setTimeout(tick, 90);   // ~2s of correction window (form open is slower than paginate)
    })();
  }
  document.addEventListener('click', function (e) {
    var t = e.target; if (!t || !t.closest) return;
    if (t.closest('.jdgm-paginate')) {
      // target the LIST top (Judge.me parks it at y=0), not the summary above it
      correctTarget(function () { return document.querySelector('.jdgm-rev-widg__reviews'); });
    } else if (t.closest('.jdgm-write-rev-link')) {
      correctTarget(function () {
        var f = document.querySelector('.jdgm-form');
        return (f && f.getBoundingClientRect().height > 50) ? f : null;
      });
    }
  }, true);
})();

/* ── SYLVI UIUX (2026-06-12): Judge.me long-review "View more" cards ──────────
   Judge.me replaces review DOM on sort/pagination, so enhance the rendered cards and watch for swaps. */
(function () {
  if (window.SylviJudgeMeReadMore) return;
  window.SylviJudgeMeReadMore = true;

  var REVIEW_SELECTOR = '.jdgm-rev-widg__reviews .jdgm-rev';
  var TOGGLE_CLASS = 'jdgm-review-toggle';
  var LONG_REVIEW_LENGTH = 220;
  var scheduled = null;

  function needsToggle(review, body) {
    var text = (body.textContent || '').replace(/\s+/g, ' ').trim();
    if (text.length > LONG_REVIEW_LENGTH) return true;

    var wasExpanded = review.classList.contains('is-expanded');
    var collapsedHeight = body.getBoundingClientRect().height;

    review.classList.add('is-expanded');
    var expandedHeight = body.getBoundingClientRect().height;
    if (!wasExpanded) review.classList.remove('is-expanded');

    return expandedHeight > collapsedHeight + 4;
  }

  function enhanceReview(review) {
    if (!review || review.getAttribute('data-sylvi-readmore') === 'true') return;

    var body = review.querySelector('.jdgm-rev__body');
    if (!body) return;

    review.setAttribute('data-sylvi-readmore', 'true');
    review.classList.remove('is-expanded');

    requestAnimationFrame(function () {
      if (!document.documentElement.contains(review)) return;

      if (!needsToggle(review, body)) {
        review.classList.add('jdgm-rev--no-toggle');
        return;
      }

      review.classList.add('jdgm-rev--has-toggle');

      var button = document.createElement('button');
      button.type = 'button';
      button.className = TOGGLE_CLASS;
      button.setAttribute('aria-expanded', 'false');
      button.textContent = 'View more';
      body.insertAdjacentElement('afterend', button);
    });
  }

  function enhanceReviews(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(REVIEW_SELECTOR).forEach(enhanceReview);
  }

  function scheduleEnhance() {
    clearTimeout(scheduled);
    scheduled = setTimeout(function () { enhanceReviews(document); }, 120);
  }

  document.addEventListener('click', function (event) {
    var button = event.target && event.target.closest ? event.target.closest('.' + TOGGLE_CLASS) : null;
    if (!button) return;

    var review = button.closest('.jdgm-rev');
    if (!review) return;

    var expanded = review.classList.toggle('is-expanded');
    button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    button.textContent = expanded ? 'View less' : 'View more';
  });

  function initReviewToggles() {
    enhanceReviews(document);

    if (!document.body || !window.MutationObserver) return;
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        for (var j = 0; j < mutations[i].addedNodes.length; j++) {
          var node = mutations[i].addedNodes[j];
          if (node.nodeType !== 1) continue;
          if (
            (node.matches && node.matches('.jdgm-rev, .jdgm-rev-widg__reviews')) ||
            (node.querySelector && node.querySelector('.jdgm-rev'))
          ) {
            scheduleEnhance();
            return;
          }
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReviewToggles);
  } else {
    initReviewToggles();
  }
})();

/* ── Skeleton shimmer: stop when image actually renders (2026-06-15) ─────────
   lazysizes adds 'lazyloaded' when it sets srcset, BEFORE the CDN fetch
   completes. We add .image-fetching (hides broken-icon) at that moment and
   remove it when the image actually loads. Works on all browsers. */
(function () {
  function markLoaded(img) {
    img.classList.remove('image-fetching');
    img.classList.add('image-ready');
    var wrap = img.closest && img.closest('.image-wrap');
    if (wrap) wrap.classList.add('image-wrap--loaded');
  }

  function markError(img) {
    img.classList.remove('image-fetching');
    var wrap = img.closest && img.closest('.image-wrap');
    if (wrap) wrap.classList.add('image-wrap--error');
  }

  /* Lazysizes fires 'lazyloaded' when srcset is set — CDN fetch not yet done */
  document.addEventListener('lazyloaded', function (e) {
    var img = e.target;
    if (!img || img.tagName !== 'IMG') return;
    var wrap = img.closest && img.closest('.image-wrap');
    if (!wrap) return;

    if (img.complete && img.naturalWidth > 0) { markLoaded(img); return; }
    if (img.complete && img.naturalWidth === 0) { markError(img); return; }

    /* Image is now fetching from CDN — hide broken-icon during this window */
    img.classList.add('image-fetching');
    img.addEventListener('load',  function () { markLoaded(img); }, { once: true });
    img.addEventListener('error', function () { markError(img);  }, { once: true });
  });

  /* Handle baked-in lazyloaded images (main PDP hero, eagerly-loaded).
     These never fire the lazysizes 'lazyloaded' event, so we handle them here.
     Also fixes the still-loading case: attach listeners if img not yet complete. */
  function checkExistingImages() {
    var imgs = document.querySelectorAll('.image-wrap img.lazyloaded');
    for (var i = 0; i < imgs.length; i++) {
      (function (img) {
        if (img.complete && img.naturalWidth > 0) { markLoaded(img); }
        else if (img.complete) { markError(img); }
        else {
          img.addEventListener('load',  function () { markLoaded(img); }, { once: true });
          img.addEventListener('error', function () { markError(img);  }, { once: true });
        }
      })(imgs[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkExistingImages);
  } else {
    checkExistingImages();
  }
})();
